import CardBase from "./CardBase.js";
export default CardBase;